import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tamra_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// ---- Public ----
export const fetchSite = () => client.get("/site").then((r) => r.data);
export const submitContact = (payload) => client.post("/contact", payload).then((r) => r.data);

// ---- Auth ----
export const login = (username, password) =>
  client.post("/auth/login", { username, password }).then((r) => r.data);

// ---- Admin ----
export const updateSettings = (data) => client.put("/admin/settings", data).then((r) => r.data);
export const updateStory = (data) => client.put("/admin/story", data).then((r) => r.data);
export const upsertItem = (coll, item) =>
  (item && item.id
    ? client.put(`/admin/${coll}/${item.id}`, item)
    : client.post(`/admin/${coll}`, item)
  ).then((r) => r.data);
export const deleteItem = (coll, id) => client.delete(`/admin/${coll}/${id}`).then((r) => r.data);
export const listSubmissions = () => client.get("/admin/submissions").then((r) => r.data);
export const deleteSubmission = (id) => client.delete(`/admin/submissions/${id}`).then((r) => r.data);

export default client;
